import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@cargomatic/ui';
import { Trash2 } from 'lucide-react';
const DeleteButton = ({ disabled, onClick, title, id, dataTestId }) => {
    return (React.createElement(Button, { id: id, variant: "ghost", size: "icon", className: "h-8 w-8 text-muted-foreground hover:text-foreground", disabled: disabled, onClick: (e) => {
            e.preventDefault();
            onClick(e);
        }, title: title, "data-testid": dataTestId || 'deleteButton' },
        React.createElement(Trash2, { className: "h-4 w-4" })));
};
DeleteButton.propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    title: PropTypes.string,
    dataTestId: PropTypes.string,
};
DeleteButton.defaultProps = {
    disabled: false,
    title: '',
    onClick: () => { },
};
export default DeleteButton;
